import React from 'react';
import axios from 'axios';
import { orderStudents } from '../utils/studentOrder';

const ACTIVITIES_PER_EXPORT = 6;

function chunkRows(rows, size) {
    const chunks = [];
    for (let index = 0; index < rows.length; index += size) chunks.push(rows.slice(index, index + size));
    return chunks.length > 0 ? chunks : [[]];
}

export default function CreatePdfClasse({idClasse, allNoteSeance, positionEleve, onReady}) {
    React.useEffect(() => {
        let isMounted = true;
        onReady?.(null);

        async function loadReportData() {
            try {
                const [classResponse, studentsResponse, noteResponses] = await Promise.all([
                    axios.get(`https://eps.acces-editions.com/api/getMyClasseId?id_classe=${idClasse}`),
                    axios.get(`https://eps.acces-editions.com/api/getEleve?id_classe=${idClasse}`),
                    Promise.all(allNoteSeance.map((activity) => (
                        axios.get(`https://eps.acces-editions.com/api/getNoteEleveSceance?id_classe=${idClasse}&id_seance=${activity.id}`)
                    ))),
                ]);

                if (!isMounted) return;

                const students = Array.isArray(studentsResponse.data) ? studentsResponse.data : [];
                onReady?.({
                    classInfo: classResponse.data?.[0] || {nom_classe: '', nbEleves: 0, niveau: ''},
                    students: orderStudents(students, positionEleve),
                    notesBySession: allNoteSeance.map((activity, index) => ({
                        id: activity.id,
                        notes: Array.isArray(noteResponses[index].data) ? noteResponses[index].data : [],
                    })),
                    activityPages: chunkRows(allNoteSeance, ACTIVITIES_PER_EXPORT),
                });
            } catch (error) {
                if (isMounted) onReady?.(null);
            }
        }

        loadReportData();
        return () => {
            isMounted = false;
        };
    }, [idClasse, allNoteSeance, positionEleve, onReady]);

    return null;
}
